import { getCalendarConfiguration } from 'owa-calendar-configuration';
import getWeekStartDay from '../selectors/getWeekStartDay';
import getTimeIncrement from '../selectors/getTimeIncrement';
import getWorkDays from '../selectors/getWorkDays';
import getShowWeekNumbers from '../selectors/getShowWeekNumbers';
import getFirstWeekOfYear from '../selectors/getFirstWeekOfYear';
import getWorkingHoursStartTime from '../selectors/getWorkingHoursStartTime';
import getWorkingHoursEndTime from '../selectors/getWorkingHoursEndTime';
/**
 * Returns if the appearance option state is dirty
 */
export default function IsAppearanceOptionDirtyState() {
    var calendarConfiguration = getCalendarConfiguration();
    if (!calendarConfiguration) {
        return false;
    }
    return (getWeekStartDay() !== calendarConfiguration.WeekStartDay ||
        getTimeIncrement() !== calendarConfiguration.TimeIncrement ||
        getWorkDays() !== calendarConfiguration.WorkDays ||
        getShowWeekNumbers() !== calendarConfiguration.ShowWeekNumbers ||
        getFirstWeekOfYear() !== calendarConfiguration.FirstWeekOfYear ||
        getWorkingHoursStartTime() !== calendarConfiguration.WorkingHoursStartTime ||
        getWorkingHoursEndTime() !== calendarConfiguration.WorkingHoursEndTime);
}
//# sourceMappingURL=isAppearanceOptionDirty.js.map